import React, {useEffect, useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import Routes from './Routes'
import '../css/tailwind.css'
import '../css/main.css'
import '../css/animate.css'
import '../css/_components.css'
import Login from "./pages/Login/AdminUserLogin";
import {apiUserAuthoritate} from "./pages/Authorization/Actions";
import Layout1 from '../layouts/layout-1'
import {axios} from "../axiosConfig";
import {EnigooLoader} from "../MyComponent/EnigooLoader";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import LoginRoutes from "./LoginRoutes";


const App = () => {

    let [loading, setLoading] = useState(true)
    const location = useLocation();

    let token = localStorage.getItem('ath-acc-en')

    const history = useHistory();
    const dispatch = useDispatch();
    const {t} = useTranslation()
    useEffect(() => {
        if((!location.pathname.includes("/forgot-password/") && !location.pathname.includes("/verify/"))){
            authorizate()
        }else{
            setLoading(false);
        }
    },[])


    const authorizate = () => {


        if(!token) {
            setLoading(false);
            history.push("/login")
            dispatch({
                type: 'RESET'
            })
        }else {
            axios.defaults.headers.common['authorization'] = token;
            apiUserAuthoritate(token, (data) => {
                dispatch({
                    type: "SET_RIGHTS",
                    rights: data.rights,
                    superuser: data.superuser,
                    manageuser: data.manageuser,
                    subject: data.subject
                });
                setLoading(false);
            }, error => {
                localStorage.removeItem("ath-acc-en");
                setLoading(false)
                history.push("/login");
                dispatch({
                    type: 'RESET'
                })
                window.location.reload();
            })
        }
    }


    if (loading) return <div className="min-h-screen w-full p-4"><EnigooLoader text={t("loading.page")}/></div>
    if (!token) return <LoginRoutes/>
    if (token && !loading) return <Layout1><Routes/></Layout1>


}
export default App
